import React,{useState,useEffect} from 'react'
import Navbar from '../Components/Navbar'
import { useNavigate, useParams } from 'react-router-dom'
import Intro from '../Components/Intro'
import classes from './CategoryPage.module.css'
import header_logo from '../Assets/Images/images/game_overview_thumb.png'
import BrandCarousel from '../Components/BrandCarousel'
import axios from 'axios'
import { getGamesApi } from '../Services/Api'
import GameList from './GameList'
import Footer from '../Components/Footer'
import BrandCarousel2 from '../Components/BrandCarousel2'



const CategoryPage = () => {

    const {category} = useParams()
    const [data,setData] = useState([])

    const navigate = useNavigate()

    const getData = async()=>{
      try{
        const res = await axios.get(getGamesApi);
        console.log(res.data.response)

        const newArr = res.data.response.find((item)=>item.category == category)
        console.log(newArr.game)
  
        setData(newArr.game)
      }
      catch(err){
        console.log(err);
        navigate('/error')
      }
    }
  
    useEffect(()=>{
      getData();
     
    },[category])


    

  return (
    <div>
      <Navbar active={category}/>
      <Intro/>
      <div className={classes.categoryHeaderContainer}>
      <div className={classes.categoryHeader}>
      <span> <img src={header_logo} alt='...'/> {category} Games</span>
      </div>
      <div className={classes.carousel}>
      <BrandCarousel />
      </div>

      </div>

      <div >
        <GameList data={data}/>
      </div>
      
      
      <BrandCarousel2/>
      <Footer/>
    </div>
  )
}

export default CategoryPage
